export default __webpack_public_path__ + "static/media/bnr-2.b6766549.png";